<script setup lang="ts">
    import type { ProductsCollectionData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    /**
     * Products Widget Container
     * loads a collection via the api and renders a set of cards for each product
     * while loading the collection, a skeleton should be rendered
     * we only fetch the first collection in the array
     */
    const props = defineProps<IWidgetProps<ProductsCollectionData>>();
    const { data } = useWidget(props);

    const collectionId = data.collections?.length ? `${data.collections[0].id}` : '';

    const { data: products, status } = useProductCollection(collectionId, Boolean(collectionId));

    const background = computed(() => {
        return data.style?.background_color;
    });
</script>
<template>
    <!-- Empty div fixes the hydration issue -->
    <org-product-grid
        v-if="status === 'success' && products?.length"
        :products="products"
        :background="background"
        :intro="data.intro" />
    <div v-else></div>
</template>
